export const LOGIN_PATH = '/login';
export const LOGIN_CALLBACK_PATH = '/login/callback';
export const LOGOUT_REDIRECTION_CALLBACK_PATH = '/logout/callback';

/**
 * Which kind of account the user picked on the login page. It exists only to shape the
 * authorization request; it is never evidence that the resulting session really is a
 * business one. FrontOffice derives the real login context from the verified CorePass token.
 */
export const LoginMode = {
  Individual: 'individual',
  Business: 'business',
} as const;

export type TLoginMode = (typeof LoginMode)[keyof typeof LoginMode];

/** Appended to the scopes Ping already requests when the user picks the business login. */
export const BUSINESS_SCOPE = 'business';
